import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import PasswordStrengthIndicator from './PasswordStrengthIndicator';

const AccountCreationForm = ({ invitedEmail, onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    email: invitedEmail,
    password: '',
    confirmPassword: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const validatePassword = (password) => {
    const errors = [];
    if (password?.length < 8) errors?.push('At least 8 characters');
    if (!/[a-z]/?.test(password)) errors?.push('One lowercase letter');
    if (!/[A-Z]/?.test(password)) errors?.push('One uppercase letter');
    if (!/\d/?.test(password)) errors?.push('One number');
    if (!/[^a-zA-Z0-9]/?.test(password)) errors?.push('One special character');
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (errors?.[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    const newErrors = {};
    
    const passwordErrors = validatePassword(formData?.password);
    if (passwordErrors?.length > 0) {
      newErrors.password = `Password must include: ${passwordErrors?.join(', ')}`;
    }
    
    if (formData?.password !== formData?.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }
    
    if (Object.keys(newErrors)?.length > 0) {
      setErrors(newErrors);
      return;
    }
    
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
      <Input
        type="email"
        name="email"
        label="Email Address"
        value={formData?.email}
        disabled
        description="This email was provided in your invitation"
        className="opacity-75"
      />
      <div>
        <Input
          type={showPassword ? 'text' : 'password'}
          name="password"
          label="Create Password"
          placeholder="Enter a secure password"
          value={formData?.password}
          onChange={handleChange}
          error={errors?.password}
          required
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="text-xs mt-2 transition-colors duration-250"
          style={{ color: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 1)))' }}
        >
          {showPassword ? 'Hide password' : 'Show password'}
        </button>
        <PasswordStrengthIndicator password={formData?.password} />
      </div>
      <div>
        <Input
          type={showConfirmPassword ? 'text' : 'password'}
          name="confirmPassword"
          label="Confirm Password"
          placeholder="Re-enter your password"
          value={formData?.confirmPassword}
          onChange={handleChange}
          error={errors?.confirmPassword}
          required
        />
        <button
          type="button"
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          className="text-xs mt-2 transition-colors duration-250"
          style={{ color: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 1)))' }}
        >
          {showConfirmPassword ? 'Hide password' : 'Show password'}
        </button>
      </div>
      <div className="pt-4 md:pt-6">
        <Button
          type="submit"
          variant="default"
          fullWidth
          loading={loading}
          disabled={loading}
          iconName="UserPlus"
          iconPosition="left"
        >
          {loading ? 'Creating Account...' : 'Create Account'}
        </Button>
      </div>
      <div className="text-center pt-2">
        <p className="text-xs md:text-sm text-muted-foreground">
          By creating an account, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </form>
  );
};

export default AccountCreationForm;